import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import './ErrorBar.scss';

export default function ErrorBar({ errorBar, onClose }) {
  const {
    show, message
  } = errorBar;
  return (
    <React.Fragment>
      {
        show &&
        <div className="ErrorBar">
          <span className="ErrorBar__ErrorIcon">
            <Icon
              name="error-white"
            />
          </span>
          <span className="ErrorBar__Message">
            {message}
          </span>
          <span
            className="ErrorBar__CrossIcon"
            role="button"
            tabIndex="0"
            onClick={onClose}
          >
            <Icon
              name="x-icon-white"
            />
          </span>
        </div>
      }
    </React.Fragment>
  );
}

ErrorBar.propTypes = {
  errorBar: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/ErrorBar/ErrorBar.jsx